import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar } from 'react-pro-sidebar';
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useUserPermissions } from '../utils/auth';
import { PERMISSIONS } from '../constants/permissions';
import demandIcon from "@/assets/user-message-solid-full.svg";
import improvementPlanIcon from "@/assets/award-solid-full.svg";
import { useNavigationGuard } from "../contexts/NavigationGuardContext";

const SidebarMain = () => {
    const { t } = useTranslation('menu');
    const location = useLocation();
    const { collapseSidebar, collapsed } = useProSidebar();
    const permissions  = useUserPermissions();
    const { navigateWithGuard } = useNavigationGuard();
    return (
        <Sidebar className='mt-0'>
            {/* Bot�n para colapsar/expandir */}
            <div style={{
                padding: '10px',
                display: 'flex',
                justifyContent: 'flex-end',
                borderBottom: '1px solid #ccc'
            }}>
                <button
                    onClick={() => collapseSidebar()}
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '20px',
                        color: '#004367'
                    }}
                >
                    {collapsed ?
                        <i className="bi bi-chevron-right"></i> :
                        <i className="bi bi-chevron-left"></i>
                    }
                </button>
            </div>

            <Menu
                menuItemStyles={{
                    button: ({ active }) => {
                        return {
                            backgroundColor: active ? '#5db77a' : 'transparent',
                            color: '#ffffff',
                            '&:hover': {
                                backgroundColor: '#5db77a',
                                color: '#ffffff !important',
                            },
                        };
                    },
                }}
            >
                {permissions.length > 0 && permissions.includes(PERMISSIONS.GLOBAL_DASHBOARD.VIEW) && (
                    <MenuItem>
                        <i className="bi bi-grid-1x2-fill me-2"></i>
                        {!collapsed && "Global Dashboard"}
                    </MenuItem>
                )}
                {permissions.length > 0 && permissions.includes(PERMISSIONS.CLAIMS.VIEW, PERMISSIONS.PROFESSIONAL_MANAGEMENT.VIEW) && (
                <SubMenu
                    label={
                        <span>
                            <img
                                style={{ marginRight: "5px", filter: "invert(18%) sepia(99%) saturate(1200%) hue-rotate(185deg) brightness(85%)" }}
                                title={t("common:buttons.buttonSurveys")}
                                src={demandIcon}
                                alt={t("common:buttons.buttonSurveys")}
                                width={25}
                                height={25}
                            />
                            { !collapsed && t("menu:dashboard.sidebarMainClaims")}
                        </span>
                    }
                    >
                        {permissions.includes(PERMISSIONS.CLAIMS.VIEW) && (
                            <>
                            <MenuItem
                                onClick={() => navigateWithGuard("/new-claim")}
                                active={location.pathname === '/new-claim'}
                            >
                                {t("menu:dashboard.sidebarMainNewClaim")}
                            </MenuItem>
                            <MenuItem
                                onClick={() => navigateWithGuard("/claims/dashboard")}
                                active={location.pathname === '/claims/dashboard'}
                            >
                                Dashboard
                                </MenuItem>
                            </>
                        )}
                        {permissions.includes(PERMISSIONS.PROFESSIONAL_MANAGEMENT.VIEW) && (
                            <MenuItem
                                onClick={() => navigateWithGuard("/professionals")}
                                active={location.pathname === '/professionals'}
                            >
                                {t("menu:dashboard.sidebarMainProfessionals")}
                            </MenuItem>
                        )}
                </SubMenu>
                )}
                {permissions.length > 0 &&
                    (
                        permissions.includes(PERMISSIONS.SURVEYS_PATIENTS.VIEW) ||
                        permissions.includes(PERMISSIONS.SURVEY_UPLOAD.VIEW)
                    ) && (
                        <SubMenu
                            label={
                                <span>
                                    <i className="bi bi-chat-left-text-fill me-2"></i>
                                    {!collapsed && t("menu:dashboard.sidebarMainPatientSurveys")}
                                </span>
                            }
                        >
                            {permissions.includes(PERMISSIONS.SURVEYS_PATIENTS.VIEW) && (
                                <MenuItem
                                onClick={() => navigateWithGuard("/survey-patient/dashboard")}
                                active={location.pathname === "/survey-patient/dashboard"}
                                >
                                    Dashboard
                                </MenuItem>
                            )}

                            {permissions.includes(PERMISSIONS.SURVEY_UPLOAD.VIEW) && (
                                <MenuItem
                                    onClick={() => navigateWithGuard("/survey-load")}
                                    active={location.pathname === "/survey-load"}
                                >
                                    {t("menu:dashboard.sidebarMainSurveyLoad")}
                                </MenuItem>
                            )}
                        </SubMenu>
                    )}
                {permissions.length > 0 && permissions.includes(PERMISSIONS.IMPROVEMENT_PLANS.VIEW) && (
                    <SubMenu
                        defaultOpen={location.pathname.startsWith('/improvement-plans"')}
                        label={
                            <span className="d-inline-flex align-items-center">
                                <img
                                    style={{ marginRight: "5px" }}
                                    src={improvementPlanIcon}
                                    width={25} />
                                {t("menu:dashboard.sidebarMainImprovementPlans")}
                            </span>
                        }
                    >
                        {permissions.length > 0 && permissions.includes(PERMISSIONS.IMPROVEMENT_PLANS.CREATE) && (
                        <MenuItem
                            onClick={() => navigateWithGuard(`/improvement-plans/new`)}
                            active={location.pathname.includes('/improvement-plans/new')}
                        >
                            {t("improvementPlan:buttonNewImprovementPlan")}
                        </MenuItem>)}
                        <MenuItem
                            onClick={() => navigateWithGuard("/improvement-plans/dashboard")}
                            active={location.pathname.includes('/improvement-plans/dashboard')}
                        >
                            Dashboard
                        </MenuItem>

                    </SubMenu>
                )}
                {permissions.length > 0 && permissions.includes(PERMISSIONS.SOCIAL_NETWORKS.VIEW) && (
                    <MenuItem>
                        <i className="bi bi-wifi me-2"></i>
                        {!collapsed && t("menu:dashboard.sidebarMainSocialMedia")}
                    </MenuItem>
                )}
                {permissions.length > 0 && permissions.includes(PERMISSIONS.SURVEYS_PROFESSIONALS.VIEW) && (
                    <MenuItem>
                        <i className="bi bi-people-fill me-2"></i>
                        {!collapsed && t("menu:dashboard.sidebarMainProfesionalSurveys")}
                    </MenuItem>
                )}
                {permissions.length > 0 && permissions.includes(PERMISSIONS.ALERTS.VIEW) && (

                    <SubMenu
                        defaultOpen={location.pathname.startsWith('/alertes')}
                        label={
                            <span className="d-inline-flex align-items-center">
                                <i className="bi bi-exclamation-circle-fill me-2"></i>
                                {!collapsed && t("menu:dashboard.sidebarMainAlerts")}
                            </span>
                        }
                    >
                        <MenuItem
                            onClick={() => navigateWithGuard("/alertes")}
                            active={location.pathname.includes('/alertes')}
                        >
                            Kanban
                        </MenuItem>
                    </SubMenu>
                )}
            </Menu>
        </Sidebar>
    );
};

export default SidebarMain;
